/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Hinton_TitleInputs */

const en_home_quotes_hinton_title = /** @type {(inputs: Home_Quotes_Hinton_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobel Prize winner & "Godfather of AI"`)
};

/**
* | output |
* | --- |
* | "Nobel Prize winner & \"Godfather of AI\"" |
*
* @param {Home_Quotes_Hinton_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_hinton_title = /** @type {((inputs?: Home_Quotes_Hinton_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Hinton_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_hinton_title(inputs)
});